const JobTrackersContainerView = () => import('@/views/SuperAdmin/JobTrackers/JobTrackersContainerView')

const BatchItemView = () => import('@/views/SuperAdmin/JobTrackers/BatchItemView')
const BatchListView = () => import('@/views/SuperAdmin/JobTrackers/BatchListView')
const FailedJobTrackingView = () => import('@/views/SuperAdmin/JobTrackers/FailedJobTrackingView')
const FailedJobDetailView = () => import('@/views/SuperAdmin/JobTrackers/FailedJobDetailView')
const JobTrackersHomeView = () => import('@/views/SuperAdmin/JobTrackers/JobTrackersHomeView')
const JobTrackingView = () => import('@/views/SuperAdmin/JobTrackers/JobTrackingView')

export default [
    {
		component: JobTrackersContainerView,
		name: 'sa-job-trackers',
		path: 'job-trackers',
		redirect: {
			name:'sa-job-trackers-home'
		},

		children: [
			{
				component: JobTrackersHomeView,
				name: 'sa-job-trackers-home',
				path: ''
			},
			{
				component: BatchListView,
				name: 'sa-job-trackers-batches',
				path: 'batches'
			},
			{
				component: BatchItemView,
				name: 'sa-job-trackers-batch',
				path: 'batches/:batchId',
				props: route => {
					return {
						value: route?.params?.batchId
					}
				},
			},
			{
				component: FailedJobTrackingView,
				name: 'sa-job-trackers-failed_jobs',
				path: 'failed-jobs'
			},
			{
				component: FailedJobDetailView,
				name: 'sa-job-trackers-failed_job',
				path: 'failed-jobs/:failedJobId',
				props: route => {
					return {
						value: route?.params?.failedJobId
					}
				},
			},
			{
				component: JobTrackingView,
				name: 'sa-job-trackers-jobs',
				path: 'jobs'
			},
		]
	}
]